import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../auth';
import { BaseRouteComponent, DiscardChangesGuard } from '../tms-shared';

const routes: Routes = [
  {
    path: '',
    component: BaseRouteComponent,
    canActivate: [AuthGuard, DiscardChangesGuard],
    children: [
      { path: '', redirectTo: 'User', pathMatch: 'full' },
      { path: 'User', loadChildren: () => import('./user/user.module').then((m) => m.UserModule) },
      { path: 'Role', loadChildren: () => import('./role/role.module').then((m) => m.RoleModule) },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserAdminRoutingModule {}
